import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import "./admin.css";

// Initial data structure based on current code
const INITIAL_BUSINESS_DATA = {
  heroVideo: {
    title: "Business Intro Video",
    url: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/AI%20videos%2FInsight%20center%2FInsight%20center%20Business.mp4?alt=media&token=1cfdd4c6-e97b-4b29-8b8d-ff11f21e2098",
    thumbnail: "https://images.unsplash.com/photo-1550439062-609e1531270e?q=80&w=1600&auto=format&fit=crop"
  },
  sections: [
    {
      id: "row-1",
      title: "Business Overview",
      videos: [
        {
          title: "Intro to the Model",
          url: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Four_model.mp4?alt=media&token=35f461a6-6ee8-4e05-aadc-b33b1c27e033",
          thumbnail: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Comp Plan Snapshot",
          url: "https://player.vimeo.com/3680f1df-0edd-475c-8b4f-22585fd4b6cb",
          thumbnail: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Leadership Path",
          url: "https://player.vimeo.com/d4ab23b8-b8ff-41a7-be56-f05835a84b06",
          thumbnail: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Getting Paid",
          url: "https://player.vimeo.com/b0dda31f-d7c7-4df5-a784-000f25fba7b0",
          thumbnail: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=800&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "row-2",
      title: "Endorsements & Credibility",
      videos: [
        {
          title: "Industry Awards",
          url: "https://player.vimeo.com/132e2284-dc04-4876-87ee-812547916481",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6227.jpeg?alt=media&token=f934b523-0b99-4e47-bd9a-ca02a84cabd3"
        },
        {
          title: "Media Features",
          url: "https://player.vimeo.com/0a8f8bba-ea9c-4c8a-8f92-1c9e8f6f9d11",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6219.jpeg?alt=media&token=8fb90f8e-6329-4604-8fd6-14220908f02b"
        },
        {
          title: "Client Stories",
          url: "https://player.vimeo.com/4a2a6f2f-3c0a-49b0-9a1f-0e2c99f0de33",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6223.jpeg?alt=media&token=e6e37619-78ea-43e5-9f09-05e5a8daf9bb"
        },
        {
          title: "Track Record",
          url: "https://player.vimeo.com/7f1c4a77-7d1e-4f6f-8b2e-9f761a2d0b55",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6226.jpeg?alt=media&token=70a525b9-994f-4a02-be23-d6deeb4fd50a"
        },
        {
          title: "Compliance",
          url: "https://player.vimeo.com/1b8e0c27-2a0a-4f3a-9d5c-6d8c0c3f2a77",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6221.jpeg?alt=media&token=623d7446-9b12-4a4c-9fca-bc6a85b6ba01"
        }
      ]
    },
    {
      id: "row-3",
      title: "Product Provider Endorsements",
      videos: [
        {
          title: "Provider A",
          url: "https://player.vimeo.com/video/880604427?h=243273a602&title=0&byline=0&portrait=0",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Fimg_6219.jpeg?alt=media&token=8fb90f8e-6329-4604-8fd6-14220908f02b"
        },
        {
          title: "Provider B",
          url: "https://player.vimeo.com/ab2c8b64-0c9a-43bd-9f7b-7b5cf2bcd123",
          thumbnail: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Provider C",
          url: "https://player.vimeo.com/8d7a9d21-3a1a-4b94-9b6a-9029e4d3cc45",
          thumbnail: "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Provider D",
          url: "https://player.vimeo.com/5e7f0f6a-bf7f-46c4-8b4f-4238f9c6f0f0",
          thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Provider E",
          url: "https://player.vimeo.com/6e01d2ad-2d35-4f7d-b4d5-1a2a9a2b8c8c",
          thumbnail: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=800&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "row-4",
      title: "Team Testimonials",
      videos: [
        {
          title: "Path to Leader",
          url: "https://player.vimeo.com/video/880604427?h=243273a602&title=0&byline=0&portrait=0",
          thumbnail: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "First 90 Days",
          url: "https://player.vimeo.com/0b7b4e11-0d7b-4b9e-8c15-9e3c89b2f111",
          thumbnail: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Part-Time to Full-Time",
          url: "https://player.vimeo.com/2e22d3cc-6b09-4a0a-9a7f-14f9d7dbeaaa",
          thumbnail: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Culture & Mentorship",
          url: "https://player.vimeo.com/2a6b1c35-0b0f-4f9f-8f0e-4d5b3b4a2a22",
          thumbnail: "https://images.unsplash.com/photo-1517263904808-5dc91e3e7044?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Family Freedom",
          url: "https://player.vimeo.com/5c2d8f63-1c6a-4f2b-9d90-7e5a44b1cc99",
          thumbnail: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Remote Lifestyle",
          url: "https://player.vimeo.com/7b1f9d22-6c2e-4f4f-9b25-1c4d4b77aa88",
          thumbnail: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Impact Stories",
          url: "https://player.vimeo.com/9c2d3a44-1c4a-43db-9b22-3e5c6b44c0c0",
          thumbnail: "https://images.unsplash.com/photo-1516594798947-e65505dbb29d?q=80&w=800&auto=format&fit=crop"
        }
      ]
    }
  ],
  faq: [
    { question: "Do I need to be good at sales?", url: "https://player.vimeo.com/faq-1-sales-skill-video" },
    { question: "How much time does this take?", url: "https://player.vimeo.com/faq-2-time-commitment-video" },
    { question: "How do we generate clients?", url: "https://player.vimeo.com/faq-3-client-gen-video" },
    { question: "Is this a legitimate business?", url: "https://player.vimeo.com/faq-4-legitimacy-video" },
    { question: "What are the next steps to getting started?", url: "https://player.vimeo.com/faq-5-next-steps-video" },
    { question: "Is this multi-level marketing?", url: "https://player.vimeo.com/faq-6-mlm-video" },
    { question: "What are the negatives of this business?", url: "https://player.vimeo.com/faq-7-negatives-video" }
  ]
};

const INITIAL_EDUCATION_DATA = {
  heroVideo: {
    title: "Financial Education Intro Video",
    url: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/AI%20videos%2FInsight%20center%2FInsight%20center%20Education.mp4?alt=media&token=23f05108-a432-405d-bcba-6a3e9382e37c",
    thumbnail: "https://images.unsplash.com/photo-1550439062-609e1531270e?q=80&w=1600&auto=format&fit=crop"
  },
  sections: [
    {
      id: "row-1",
      title: "Videos",
      videos: [
        {
          title: "Education Overview",
          url: "https://player.vimeo.com/3680f1df-0edd-475c-8b4f-22585fd4b6cb",
          thumbnail: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "How to Use the Platform",
          url: "https://player.vimeo.com/d4ab23b8-b8ff-41a7-be56-f05835a84b06",
          thumbnail: "https://images.unsplash.com/photo-1513258496099-48168024aec0?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Study Gameplan",
          url: "https://player.vimeo.com/b0dda31f-d7c7-4df5-a784-000f25fba7b0",
          thumbnail: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Exam Tips",
          url: "https://player.vimeo.com/0a8f8bba-ea9c-4c8a-8f92-1c9e8f6f9d11",
          thumbnail: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?q=80&w=800&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "row-2",
      title: "LIRP Videos",
      videos: [
        {
          title: "What is a LIRP?",
          url: "https://player.vimeo.com/4a2a6f2f-3c0a-49b0-9a1f-0e2c99f0de33",
          thumbnail: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Tax-Advantaged Growth",
          url: "https://player.vimeo.com/7f1c4a77-7d1e-4f6f-8b2e-9f761a2d0b55",
          thumbnail: "https://images.unsplash.com/photo-1523958203904-cdcb402031fd?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Protection + Retirement",
          url: "https://player.vimeo.com/1b8e0c27-2a0a-4f3a-9d5c-6d8c0c3f2a77",
          thumbnail: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "LIRP Case Study",
          url: "https://player.vimeo.com/5f53e3a5-2b41-4f9a-8f8b-7c1c7b0ea1a1",
          thumbnail: "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?q=80&w=800&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "row-3",
      title: "Annuities Videos",
      videos: [
        {
          title: "Annuities 101",
          url: "https://player.vimeo.com/9304afe0-e1bf-4816-88a0-d44b83307c16",
          thumbnail: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Indexed Annuities",
          url: "https://player.vimeo.com/d4363bb2-3781-48ea-ae8b-6b71fd7d06c7",
          thumbnail: "https://images.unsplash.com/photo-1508385082359-f38ae991e8f2?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Payout Options & Taxes",
          url: "https://player.vimeo.com/100fc3d7-20de-46a2-864e-3673a8392f21",
          thumbnail: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=800&auto=format&fit=crop"
        },
        {
          title: "Suitability & Rules",
          url: "https://player.vimeo.com/8d7a9d21-3a1a-4b94-9b6a-9029e4d3cc45",
          thumbnail: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=800&auto=format&fit=crop"
        }
      ]
    }
  ],
  faqGeneral: [
    { question: "Where do I start?", url: "https://player.vimeo.com/faq-edu-01-start" },
    { question: "How long does it take?", url: "https://player.vimeo.com/faq-edu-02-time" },
    { question: "Do I need prior experience?", url: "https://player.vimeo.com/faq-edu-03-experience" },
    { question: "How is this different?", url: "https://player.vimeo.com/faq-edu-04-different" }
  ],
  faqAnnuities: [
    { question: "Who are annuities for?", url: "https://player.vimeo.com/faq-ann-01-who" },
    { question: "Indexed vs Fixed?", url: "https://player.vimeo.com/faq-ann-02-types" },
    { question: "What about fees?", url: "https://player.vimeo.com/faq-ann-03-fees" },
    { question: "How are payouts taxed?", url: "https://player.vimeo.com/faq-ann-04-taxes" },
    { question: "Are annuities safe?", url: "https://player.vimeo.com/faq-ann-05-safety" }
  ]
};

const INITIAL_INSIGHT_DATA = {
  mainIntro: {
    title: "Main Intro Video",
    url: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Finsight_center_intro_v2.mp4?alt=media&token=b6e04e29-69ca-4dc6-8754-75e5be9e1b5d"
  },
  easterEgg: {
    title: "Easter Egg Video",
    url: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2FLeadership%20Bonus.mp4?alt=media&token=fe0c09c7-cf66-4d70-b93b-76b7c68d26df"
  }
};

export default function VideoManagement() {
  const [selectedPage, setSelectedPage] = useState("business");
  const [businessData, setBusinessData] = useState(null);
  const [educationData, setEducationData] = useState(null);
  const [insightData, setInsightData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" });
  
  // Modal states
  const [editModal, setEditModal] = useState({ open: false, type: "", data: null, sectionId: null, videoIndex: null, sectionTitle: "" });
  const [uploadProgress, setUploadProgress] = useState({ video: 0, thumbnail: 0 });

  // Load data on mount
  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    try {
      // Business
      const businessDocRef = doc(db, "config", "business_videos");
      const businessDoc = await getDoc(businessDocRef);
      if (businessDoc.exists()) {
        setBusinessData(businessDoc.data());
      } else {
        await setDoc(businessDocRef, INITIAL_BUSINESS_DATA);
        setBusinessData(INITIAL_BUSINESS_DATA);
      }

      // Education
      const educationDocRef = doc(db, "config", "education_videos");
      const educationDoc = await getDoc(educationDocRef);
      if (educationDoc.exists()) {
        setEducationData(educationDoc.data());
      } else {
        await setDoc(educationDocRef, INITIAL_EDUCATION_DATA);
        setEducationData(INITIAL_EDUCATION_DATA);
      }

      // Insight Center
      const insightDocRef = doc(db, "config", "insight_center_videos");
      const insightDoc = await getDoc(insightDocRef);
      if (insightDoc.exists()) {
        setInsightData(insightDoc.data());
      } else {
        await setDoc(insightDocRef, INITIAL_INSIGHT_DATA);
        setInsightData(INITIAL_INSIGHT_DATA);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      showMessage("Error loading video data", "error");
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: "", type: "" }), 3000);
  };

  const openEditModal = (type, data, sectionId = null, videoIndex = null, sectionTitle = "") => {
    setEditModal({ open: true, type, data: { ...data }, sectionId, videoIndex, sectionTitle });
    setUploadProgress({ video: 0, thumbnail: 0 });
  };

  const closeEditModal = () => {
    setEditModal({ open: false, type: "", data: null, sectionId: null, videoIndex: null, sectionTitle: "" });
    setUploadProgress({ video: 0, thumbnail: 0 });
  };

  const uploadFile = async (file, path, progressType) => {
    return new Promise((resolve, reject) => {
      const storageRef = ref(storage, `${path}/${Date.now()}_${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(prev => ({ ...prev, [progressType]: progress }));
        },
        (error) => {
          console.error("Upload error:", error);
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        }
      );
    });
  };

  const handleSave = async (updatedData) => {
    try {
      setLoading(true);
      const { type, sectionId, videoIndex } = editModal;
      
      if (selectedPage === "business" || (selectedPage === "content" && type === "faq")) {
        let newData = { ...businessData };
        
        if (type === "hero") {
          newData.heroVideo = updatedData;
        } else if (type === "video") {
          const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
          if (sectionIdx !== -1) {
            newData.sections[sectionIdx].videos[videoIndex] = updatedData;
          }
        } else if (type === "faq") {
          newData.faq[videoIndex] = updatedData;
        }
        
        const docRef = doc(db, "config", "business_videos");
        await setDoc(docRef, newData);
        setBusinessData(newData);
      } else if (selectedPage === "education"  || (selectedPage === "content" && (type === "faq-general" || type === "faq-annuities"))) {
        let newData = { ...educationData };
        
        if (type === "hero") {
          newData.heroVideo = updatedData;
        } else if (type === "video") {
          const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
          if (sectionIdx !== -1) {
            newData.sections[sectionIdx].videos[videoIndex] = updatedData;
          }
        } else if (type === "faq-general") {
          newData.faqGeneral[videoIndex] = updatedData;
        } else if (type === "faq-annuities") {
          newData.faqAnnuities[videoIndex] = updatedData;
        }
        
        const docRef = doc(db, "config", "education_videos");
        await setDoc(docRef, newData);
        setEducationData(newData);
      } else if (selectedPage === "insight") {
        let newData = { ...insightData };
        
        if (type === "mainIntro") {
          newData.mainIntro = updatedData;
        } else if (type === "easterEgg") {
          newData.easterEgg = updatedData;
        }
        
        const docRef = doc(db, "config", "insight_center_videos");
        await setDoc(docRef, newData);
        setInsightData(newData);
      }
      
      showMessage("Saved successfully!", "success");
      closeEditModal();
    } catch (error) {
      console.error("Error saving:", error);
      showMessage("Error saving changes", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSectionTitle = async (sectionId, newTitle) => {
    try {
      if (selectedPage === "business") {
        let newData = { ...businessData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].title = newTitle;
          const docRef = doc(db, "config", "business_videos");
          await setDoc(docRef, newData);
          setBusinessData(newData);
          showMessage("Section title updated!", "success");
        }
      } else if (selectedPage === "education") {
        let newData = { ...educationData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].title = newTitle;
          const docRef = doc(db, "config", "education_videos");
          await setDoc(docRef, newData);
          setEducationData(newData);
          showMessage("Section title updated!", "success");
        }
      }
    } catch (error) {
      console.error("Error updating section title:", error);
      showMessage("Error updating title", "error");
    }
  };

  const handleAddVideo = async (sectionId) => {
    try {
      const newVideo = {
        title: "New Video",
        url: "",
        thumbnail: "https://images.unsplash.com/photo-1541534401786-2077eed87a72?q=80&w=800&auto=format&fit=crop"
      };

      if (selectedPage === "business") {
        let newData = { ...businessData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].videos.push(newVideo);
          const docRef = doc(db, "config", "business_videos");
          await setDoc(docRef, newData);
          setBusinessData(newData);
          showMessage("Video added successfully!", "success");
        }
      } else if (selectedPage === "education") {
        let newData = { ...educationData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].videos.push(newVideo);
          const docRef = doc(db, "config", "education_videos");
          await setDoc(docRef, newData);
          setEducationData(newData);
          showMessage("Video added successfully!", "success");
        }
      }
    } catch (error) {
      console.error("Error adding video:", error);
      showMessage("Error adding video", "error");
    }
  };

  const handleDeleteVideo = async (sectionId, videoIndex) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {
      if (selectedPage === "business") {
        let newData = { ...businessData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].videos.splice(videoIndex, 1);
          const docRef = doc(db, "config", "business_videos");
          await setDoc(docRef, newData);
          setBusinessData(newData);
          showMessage("Video deleted successfully!", "success");
        }
      } else if (selectedPage === "education") {
        let newData = { ...educationData };
        const sectionIdx = newData.sections.findIndex(s => s.id === sectionId);
        if (sectionIdx !== -1) {
          newData.sections[sectionIdx].videos.splice(videoIndex, 1);
          const docRef = doc(db, "config", "education_videos");
          await setDoc(docRef, newData);
          setEducationData(newData);
          showMessage("Video deleted successfully!", "success");
        }
      }
    } catch (error) {
      console.error("Error deleting video:", error);
      showMessage("Error deleting video", "error");
    }
  };

  const handleDeleteFAQ = async (faqType, faqIndex) => {
    if (!window.confirm("Are you sure you want to delete this FAQ?")) return;

    try {
      if (faqType === "faq") {
        let newData = { ...businessData };
        newData.faq.splice(faqIndex, 1);
        const docRef = doc(db, "config", "business_videos");
        await setDoc(docRef, newData);
        setBusinessData(newData);
        showMessage("FAQ deleted successfully!", "success");
      } else if (faqType === "faq-general") {
        let newData = { ...educationData };
        newData.faqGeneral.splice(faqIndex, 1);
        const docRef = doc(db, "config", "education_videos");
        await setDoc(docRef, newData);
        setEducationData(newData);
        showMessage("FAQ deleted successfully!", "success");
      } else if (faqType === "faq-annuities") {
        let newData = { ...educationData };
        newData.faqAnnuities.splice(faqIndex, 1);
        const docRef = doc(db, "config", "education_videos");
        await setDoc(docRef, newData);
        setEducationData(newData);
        showMessage("FAQ deleted successfully!", "success");
      }
    } catch (error) {
      console.error("Error deleting FAQ:", error);
      showMessage("Error deleting FAQ", "error");
    }
  };

  const handleAddFAQ = async (faqType) => {
    try {
      const newFAQ = {
        question: "New FAQ Question",
        url: ""
      };

      if (faqType === "faq") {
        let newData = { ...businessData };
        if (!newData.faq) newData.faq = [];
        newData.faq.push(newFAQ);
        const docRef = doc(db, "config", "business_videos");
        await setDoc(docRef, newData);
        setBusinessData(newData);
        showMessage("FAQ added successfully! Click Edit to update.", "success");
      } else if (faqType === "faq-general") {
        let newData = { ...educationData };
        if (!newData.faqGeneral) newData.faqGeneral = [];
        newData.faqGeneral.push(newFAQ);
        const docRef = doc(db, "config", "education_videos");
        await setDoc(docRef, newData);
        setEducationData(newData);
        showMessage("FAQ added successfully! Click Edit to update.", "success");
      } else if (faqType === "faq-annuities") {
        let newData = { ...educationData };
        if (!newData.faqAnnuities) newData.faqAnnuities = [];
        newData.faqAnnuities.push(newFAQ);
        const docRef = doc(db, "config", "education_videos");
        await setDoc(docRef, newData);
        setEducationData(newData);
        showMessage("FAQ added successfully! Click Edit to update.", "success");
      }
    } catch (error) {
      console.error("Error adding FAQ:", error);
      showMessage("Error adding FAQ", "error");
    }
  };

  if (loading && !businessData && !educationData && !insightData) {
    return (
      <div className="admin-page">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading video data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page video-management-modern">
      <div className="admin-header">
        <div>
          <h1 className="admin-title">🎬 Video Management</h1>
          <p className="admin-subtitle">Manage all videos across your platform</p>
        </div>
        <div className="video-page-tabs">
          <button
            className={`tab-btn ${selectedPage === "business" ? "active" : ""}`}
            onClick={() => setSelectedPage("business")}
          >
            📊 Business
          </button>
          <button
            className={`tab-btn ${selectedPage === "education" ? "active" : ""}`}
            onClick={() => setSelectedPage("education")}
          >
            📚 Education
          </button>
          <button
            className={`tab-btn ${selectedPage === "insight" ? "active" : ""}`}
            onClick={() => setSelectedPage("insight")}
          >
            💡 Insight
          </button>
          <button
            className={`tab-btn ${selectedPage === "content" ? "active" : ""}`}
            onClick={() => setSelectedPage("content")}
          >
            🎨 Content Management
          </button>
        </div>
      </div>

      {message.text && (
        <div className={`message message-${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="video-content-modern">
        {selectedPage === "insight" && insightData && (
          <InsightCenterContent
            data={insightData}
            onEdit={openEditModal}
          />
        )}

        {selectedPage === "business" && businessData && (
          <PageContent
            data={businessData}
            onEdit={openEditModal}
            onAddVideo={handleAddVideo}
            onDeleteVideo={handleDeleteVideo}
            onUpdateSectionTitle={handleUpdateSectionTitle}
            pageType="business"
          />
        )}

        {selectedPage === "education" && educationData && (
          <PageContent
            data={educationData}
            onEdit={openEditModal}
            onAddVideo={handleAddVideo}
            onDeleteVideo={handleDeleteVideo}
            onUpdateSectionTitle={handleUpdateSectionTitle}
            pageType="education"
          />
        )}

        {selectedPage === "content" && (
          <div className="page-sections">
            {/* Business FAQ Section */}
            {businessData && (
              <div className="section-modern">
                <div className="section-title-row">
                  <h2 className="section-title-modern">📊 Business FAQ Videos</h2>
                  <button 
                    className="btn-add-section"
                    style={{ width: '220px' }}
                    onClick={() => handleAddFAQ("faq")}
                    title="Add new FAQ question"
                  >
                    ➕ Add FAQ
                  </button>
                </div>
                <div className="videos-grid-modern">
                  {businessData.faq && businessData.faq.map((item, idx) => (
                    <div key={idx} className="video-card-modern faq-card">
                      <div className="video-card-body">
                        <div className="faq-header-row">
                          <span className="video-badge">FAQ {idx + 1}</span>
                          <h3 className="video-card-title">{item.question}</h3>
                        </div>
                        <div className="video-card-actions">
                          <button 
                            className="btn-edit-video"
                            onClick={() => openEditModal("faq", item, null, idx, "Business FAQ")}
                          >
                            ✏️ Edit
                          </button>
                          <button 
                            className="btn-delete-video"
                            onClick={() => handleDeleteFAQ("faq", idx)}
                          >
                            🗑️ Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Education FAQ Section */}
            {educationData && (
              <>
                {/* General FAQ */}
                <div className="section-modern">
                  <div className="section-title-row">
                    <h2 className="section-title-modern">📚 Education - General FAQ</h2>
                    <button 
                      className="btn-add-section"
                      style={{ width: '220px' }}
                      onClick={() => handleAddFAQ("faq-general")}
                      title="Add new FAQ question"
                    >
                      ➕ Add FAQ
                    </button>
                  </div>
                  <div className="videos-grid-modern">
                    {educationData.faqGeneral && educationData.faqGeneral.map((item, idx) => (
                      <div key={`general-${idx}`} className="video-card-modern faq-card">
                        <div className="video-card-body">
                          <div className="faq-header-row">
                            <span className="video-badge">FAQ {idx + 1}</span>
                            <h3 className="video-card-title">{item.question}</h3>
                          </div>
                          <div className="video-card-actions">
                            <button 
                              className="btn-edit-video"
                              onClick={() => openEditModal("faq-general", item, null, idx, "General FAQ")}
                            >
                              ✏️ Edit
                            </button>
                            <button 
                              className="btn-delete-video"
                              onClick={() => handleDeleteFAQ("faq-general", idx)}
                            >
                              🗑️ Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Annuities FAQ */}
                <div className="section-modern">
                  <div className="section-title-row">
                    <h2 className="section-title-modern">📚 Education - Annuities FAQ</h2>
                    <button 
                      className="btn-add-section"
                      style={{ width: '220px' }}
                      onClick={() => handleAddFAQ("faq-annuities")}
                      title="Add new FAQ question"
                    >
                      ➕ Add FAQ
                    </button>
                  </div>
                  <div className="videos-grid-modern">
                    {educationData.faqAnnuities && educationData.faqAnnuities.map((item, idx) => (
                      <div key={`annuities-${idx}`} className="video-card-modern faq-card">
                        <div className="video-card-body">
                          <div className="faq-header-row">
                            <span className="video-badge">FAQ {idx + 1}</span>
                            <h3 className="video-card-title">{item.question}</h3>
                          </div>
                          <div className="video-card-actions">
                            <button 
                              className="btn-edit-video"
                              onClick={() => openEditModal("faq-annuities", item, null, idx, "Annuities FAQ")}
                            >
                              ✏️ Edit
                            </button>
                            <button 
                              className="btn-delete-video"
                              onClick={() => handleDeleteFAQ("faq-annuities", idx)}
                            >
                              🗑️ Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {editModal.open && (
        <VideoEditModal
          modal={editModal}
          onClose={closeEditModal}
          onSave={handleSave}
          uploadFile={uploadFile}
          uploadProgress={uploadProgress}
        />
      )}
    </div>
  );
}

// Insight Center Content Component
function InsightCenterContent({ data, onEdit }) {
  return (
    <div className="videos-grid-modern">
      <VideoCard
        video={{ ...data.mainIntro, thumbnail: "https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=800" }}
        onEdit={() => onEdit("mainIntro", data.mainIntro)}
        badge="Hero Video"
      />
      <VideoCard
        video={{ ...data.easterEgg, thumbnail: "https://images.unsplash.com/photo-1511988617509-a57c8a288659?w=800" }}
        onEdit={() => onEdit("easterEgg", data.easterEgg)}
        badge="Easter Egg"
      />
    </div>
  );
}

// Page Content Component (Business/Education)
function PageContent({ data, onEdit, onAddVideo, onDeleteVideo, onUpdateSectionTitle, pageType }) {
  const [editingSectionId, setEditingSectionId] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");

  const startEditingSection = (sectionId, currentTitle) => {
    setEditingSectionId(sectionId);
    setEditingTitle(currentTitle);
  };

  const saveSectionTitle = (sectionId) => {
    if (editingTitle.trim()) {
      onUpdateSectionTitle(sectionId, editingTitle);
    }
    setEditingSectionId(null);
  };

  return (
    <div className="page-sections">
      {/* Hero Video */}
      <div className="section-modern">
        <h2 className="section-title-modern">Hero Video</h2>
        <div className="videos-grid-modern">
          <VideoCard
            video={data.heroVideo}
            onEdit={() => onEdit("hero", data.heroVideo)}
            badge="Hero"
          />
        </div>
      </div>

      {/* Video Sections */}
      {data.sections.map((section) => (
        <div key={section.id} className="section-modern">
          <div className="section-title-row">
            {editingSectionId === section.id ? (
              <div className="section-title-edit">
                <input
                  type="text"
                  value={editingTitle}
                  onChange={(e) => setEditingTitle(e.target.value)}
                  className="section-title-input"
                  onKeyPress={(e) => e.key === "Enter" && saveSectionTitle(section.id)}
                  autoFocus
                />
                <button
                  className="btn-save-section"
                  onClick={() => saveSectionTitle(section.id)}
                >
                  ✓ Save
                </button>
                <button
                  className="btn-cancel-section"
                  onClick={() => setEditingSectionId(null)}
                >
                  ✕
                </button>
              </div>
            ) : (
              <>
                <h2 className="section-title-modern">{section.title}</h2>
                <div className="section-actions">
                  <button
                    className="btn-edit-section"
                    onClick={() => startEditingSection(section.id, section.title)}
                  >
                    ✏️ Edit Title
                  </button>
                  <button
                    className="btn-add-video-modern"
                    onClick={() => onAddVideo(section.id)}
                  >
                    + Add Video
                  </button>
                </div>
              </>
            )}
          </div>
          <div className="videos-grid-modern">
            {section.videos.map((video, idx) => (
              <VideoCard
                key={idx}
                video={video}
                onEdit={() => onEdit("video", video, section.id, idx, section.title)}
                onDelete={() => onDeleteVideo(section.id, idx)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// Video Card Component
function VideoCard({ video, onEdit, onDelete, badge }) {
  return (
    <div className="video-card-modern">
      <div className="video-thumbnail-modern">
        <img src={video.thumbnail || "https://images.unsplash.com/photo-1541534401786-2077eed87a72?w=800"} alt={video.title} />
        {badge && <span className="video-badge">{badge}</span>}
        <div className="video-overlay">
          <button className="btn-edit-video" onClick={onEdit}>
            ✏️ Edit Video
          </button>
        </div>
      </div>
      <div className="video-card-body">
        <h3 className="video-card-title">{video.title}</h3>
        <div className="video-card-actions">
          {onDelete && (
            <button className="btn-delete-video" onClick={onDelete}>
              🗑️ Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// Video Edit Modal
function VideoEditModal({ modal, onClose, onSave, uploadFile, uploadProgress }) {
  const [formData, setFormData] = useState({ ...modal.data });
  const [uploading, setUploading] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const url = await uploadFile(file, "videos", "video");
      handleChange("url", url);
    } catch (error) {
      alert("Error uploading video: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleThumbnailUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const url = await uploadFile(file, "thumbnails", "thumbnail");
      handleChange("thumbnail", url);
    } catch (error) {
      alert("Error uploading thumbnail: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="video-modal-modern" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-modern">
          <div>
            <h3>Edit Video</h3>
            {modal.sectionTitle && <p className="modal-subtitle">{modal.sectionTitle}</p>}
          </div>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        <form className="modal-form-modern" onSubmit={handleSubmit}>
          {/* Thumbnail Preview - Only for Videos */}
          {!(modal.type === "faq" || modal.type === "faq-general" || modal.type === "faq-annuities") && (
            <div className="thumbnail-preview-section">
              <div className="thumbnail-preview">
                <img src={formData.thumbnail || "https://images.unsplash.com/photo-1541534401786-2077eed87a72?w=800"} alt="Thumbnail" />
              </div>
              <div className="upload-info">
                <h4>Thumbnail</h4>
                <p>Upload a custom thumbnail or provide a URL</p>
              </div>
            </div>
          )}

          {/* Video Title or FAQ Question */}
          {(modal.type === "faq" || modal.type === "faq-general" || modal.type === "faq-annuities") ? (
            <div className="form-group-modern">
              <label>FAQ Question</label>
              <input
                type="text"
                value={formData.question || ""}
                onChange={(e) => handleChange("question", e.target.value)}
                placeholder="Enter FAQ question..."
                required
              />
            </div>
          ) : (
            <div className="form-group-modern">
              <label>Video Title</label>
              <input
                type="text"
                value={formData.title || ""}
                onChange={(e) => handleChange("title", e.target.value)}
                placeholder="Enter video title..."
                required
              />
            </div>
          )}

          {/* Video Upload/URL */}
          <div className="form-group-modern">
            <label>Video</label>
            <div className="upload-section">
              <div className="upload-option">
                <label className="upload-button">
                  <input
                    type="file"
                    accept="video/*"
                    onChange={handleVideoUpload}
                    style={{ display: "none" }}
                    disabled={uploading}
                  />
                  📹 Upload Video File
                </label>
                {uploadProgress.video > 0 && uploadProgress.video < 100 && (
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${uploadProgress.video}%` }}>
                      {Math.round(uploadProgress.video)}%
                    </div>
                  </div>
                )}
              </div>
              <div className="upload-divider">OR</div>
              <input
                type="url"
                value={formData.url || ""}
                onChange={(e) => handleChange("url", e.target.value)}
                placeholder="Paste video URL (Vimeo, Firebase, etc.)"
                required
              />
            </div>
          </div>

          {/* Thumbnail Upload/URL - Only for Videos */}
          {!(modal.type === "faq" || modal.type === "faq-general" || modal.type === "faq-annuities") && (
            <div className="form-group-modern">
              <label>Thumbnail</label>
              <div className="upload-section">
                <div className="upload-option">
                  <label className="upload-button">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleThumbnailUpload}
                      style={{ display: "none" }}
                      disabled={uploading}
                    />
                    🖼️ Upload Thumbnail
                  </label>
                  {uploadProgress.thumbnail > 0 && uploadProgress.thumbnail < 100 && (
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${uploadProgress.thumbnail}%` }}>
                        {Math.round(uploadProgress.thumbnail)}%
                      </div>
                    </div>
                  )}
                </div>
                <div className="upload-divider">OR</div>
                <input
                  type="url"
                  value={formData.thumbnail || ""}
                  onChange={(e) => handleChange("thumbnail", e.target.value)}
                  placeholder="Paste thumbnail URL"
                />
              </div>
            </div>
          )}

          <div className="modal-actions-modern">
            <button type="button" className="btn-cancel-modern" onClick={onClose} disabled={uploading}>
              Cancel
            </button>
            <button type="submit" className="btn-save-modern" disabled={uploading}>
              {uploading ? "Uploading..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
